import { useMemo } from "react";
import { getOptionsSelected } from "../../../../../helpers/forms/select.js";
const usePersonCounter = (props)=>{
    const { select ={} , selectedOptions =[]  } = props;
    const hasOptions = !!select?.options?.length && !!selectedOptions?.length && !!select?.onChange;
    const selectedValues = useMemo(()=>getOptionsSelected(select?.options, selectedOptions), [
        select?.options,
        selectedOptions
    ]);
    return {
        hasOptions,
        selectedValues
    };
};
export default usePersonCounter;

//# sourceMappingURL=usePersonCounter.js.map